module.exports = __webpack_public_path__ + "resources/img/equipment_tab3_img5_m.6bcd7750f622d2ee623854fdae35d0c0.jpg";